import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription, filter } from 'rxjs';

/**
 * PLAN-Pitts-Juana-General-FRONT.md §7.2 — Juana disponible en cualquier
 * pantalla del dashboard. Se monta UNA sola vez en dashboard.component.html
 * (hermano de .dashboard-container, fuera del <router-outlet>), así que no hay
 * que declararla en ningún módulo hijo.
 *
 * Reusa <app-agent-panel> tal cual para el estado abierto: mismo
 * JuanaChatService (root-provided), mismo card-renderer, misma conversación —
 * el widget es solo el envoltorio de presentación, no un segundo chat.
 *
 * Regla de visibilidad (decisión #3 del plan, parcialmente abierta): se oculta
 * donde Juana YA está presente, para no mostrar dos chats a la vez —
 * /dashboard/repuestos (panel fijo) y /dashboard/main (el home ES Juana). El
 * resto de reglas pendientes (gating por rol o por plan, y si el estado
 * abierto/cerrado se recuerda entre sesiones) siguen sin definir: hoy arranca
 * cerrado siempre y no se persiste.
 */
@Component({
  selector: 'app-juana-widget',
  standalone: false,
  templateUrl: './juana-widget.component.html',
  styleUrl: './juana-widget.component.scss',
})
export class JuanaWidgetComponent implements OnInit, OnDestroy {
  open = false;
  /** El globo de saludo se muestra hasta que el usuario abre el chat una vez. */
  showTeaser = true;
  hidden = false;

  private sub?: Subscription;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.applyVisibility(this.router.url);
    this.sub = this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe(e => this.applyVisibility((e as NavigationEnd).urlAfterRedirects));
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  private applyVisibility(url: string): void {
    const section = url.split('/')[2] ?? '';
    this.hidden = section === 'repuestos' || section === 'main';
    if (this.hidden) this.open = false;
  }

  toggle(): void {
    this.open = !this.open;
    if (this.open) this.showTeaser = false;
  }

  dismissTeaser(event: Event): void {
    event.stopPropagation();
    this.showTeaser = false;
  }
}
